import { Container } from "@mui/material";
import React from "react";
import LandingPageMainCard from "../UI/LandingPageMainCard";
import classes from "./LandingPageMain.module.css";

const LandingPageMain = () => {
  return (
    <Container sx={{padding:0}}>
      <div className={classes.topic}>
        <h1>
          <span className={classes.journey}>Journey</span>{" "}
          <span className={classes.analytics}>Analytics</span>
        </h1>
        <br />
        <p>
          Journey Analytics enables you to build Customer 360 Data Applications
          in the cloud with easier tracking of Journey stages across variety of
          Platforms.
        </p>
      </div>
      <div className={classes.mainCards}>
        <LandingPageMainCard>
          <h5>What is Journey Analytics platform?</h5>
          <p>
            Journey Analytics platform enables tracking major transitions of
            stakeholders in easy to analyze format. Instead of investing in
            costly infrastructure to implement data analytics you can leverage
            Cloud technologies to connect data from multiple systems and
            generate insights quickly. Our platform is designed to support
            variety of Journeys.
          </p>
        </LandingPageMainCard>
        <LandingPageMainCard>
          <h5>
            Following is a sample list of journeys we are starting to support.
          </h5>
          <ul>
            <li>B2B Customer Journeys</li>
            <li>Employee Journeys</li>
            <li>Student Journeys</li>
            <li>Partner Journeys</li>
            <li>Vendor Journeys</li>
            <li>High Touch Sales Journeys across industries</li>
            <ul>
              <li>Construction</li>
              <li>Real Estate</li>
              <li>Legal</li>
            </ul>
          </ul>
        </LandingPageMainCard>
      </div>
      <div className={classes.mainCards}>
        <LandingPageMainCard>
          <h5>When will I get return on investment from analytics?</h5>
          <p>
            There is no fixed formula on how quickly you will get value for your
            investment. Sometimes it can take a few weeks to realize value. It
            depends on volume data (historical and current) on what reliable
            insights you can get. Data needs to reach a statistical significance
            before you can start relying on data.
          </p>
        </LandingPageMainCard>

        <LandingPageMainCard>
          <h5>I get it now, how much will it cost me to implement Journey Analytics Platform?</h5>
          <p>
            Don’t consider analytics implementation as a cost. It is investment
            to help you get better. Our goal is to provide an affordable
            platform based on your needs. Our experts (or partners) can guide
            you through what you can expect based on your specific needs.
          </p>
        </LandingPageMainCard>
      </div>
    </Container>    
  );
};

export default LandingPageMain;
